// Depedencies
import React from 'react';

// Types
import { Components, Types } from "../types";

// Dependencies
import { useContext } from 'react';

// Contexts
import SwatchesSelect from './Select/SwatchesSelect';
import DropdownSelect from './Select/DropdownSelect';

const selectTypesMap: any = {
    'swatches': SwatchesSelect,
    'dropdown': DropdownSelect 
} 

const Select = ({type, ...selectProps}: any) => {

    const Select: any = React.useMemo(
        () => { 
            if (!(type in selectTypesMap)) {
                return null;
            }
            return selectTypesMap[type];
        }, [type]
    )
    
    if (!Select) throw Error(`Select type ${type} is not supported.`);

    return <Select {...selectProps} />
 
}

export default Select;  